/**
 * Independent add-to-cart for product page accessory compare table (not tied to main product form).
 */
(function () {
  function qtyFromInput(input) {
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < 1) return 1;
    return Math.min(n, 999);
  }

  function bindColumn(key, panel) {
    var cells = panel.querySelectorAll('[data-acc-column="' + key + '"]');
    if (cells.length < 2) return;

    var qtyCell = cells[0];
    var atcCell = cells[1];
    var input = qtyCell.querySelector('[data-acc-qty-input]');
    var minus = qtyCell.querySelector('[data-acc-qty-minus]');
    var plus = qtyCell.querySelector('[data-acc-qty-plus]');
    var btn = atcCell.querySelector('[data-acc-atc]');

    if (!input) return;

    if (minus) {
      minus.addEventListener('click', function () {
        input.value = String(Math.max(1, qtyFromInput(input) - 1));
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        input.value = String(Math.min(999, qtyFromInput(input) + 1));
      });
    }

    if (btn && !btn.disabled) {
      btn.addEventListener('click', function () {
        var vid = btn.getAttribute('data-variant-id');
        if (!vid) return;
        var qty = qtyFromInput(input);
        var url = (window.theme && theme.routes && theme.routes.cartAdd) ? theme.routes.cartAdd : '/cart/add.js';

        btn.disabled = true;
        btn.classList.add('btn--loading');

        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (body) {
                var msg = (body && (body.description || body.message)) ? (body.description || body.message) : 'Cart error';
                throw new Error(msg);
              });
            }
            return res.json();
          })
          .then(function (data) {
            if (window.theme && theme.settings && theme.settings.cartType === 'page' && theme.routes && theme.routes.cartPage) {
              window.location.assign(theme.routes.cartPage);
              return;
            }
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: { product: data },
              bubbles: true
            }));
          })
          .catch(function (err) {
            alert(err.message || 'Could not add to cart');
          })
          .finally(function () {
            btn.classList.remove('btn--loading');
            btn.disabled = false;
          });
      });
    }
  }

  function bindLightbox(root) {
    var lb = root.querySelector('[data-acc-lightbox]');
    if (!lb) return;

    var img = lb.querySelector('.accessory-compare__lightbox-img');
    if (!img) return;

    function open(src, alt) {
      if (!src) return;
      img.src = src;
      img.alt = alt || '';
      var vp = lb.querySelector('.accessory-compare__lightbox-viewport');
      if (vp) {
        vp.scrollTop = 0;
        vp.scrollLeft = 0;
      }
      lb.removeAttribute('hidden');
      lb.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lb.setAttribute('hidden', '');
      lb.setAttribute('aria-hidden', 'true');
      img.src = '';
      img.alt = '';
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('a[href]')) return;
      var trig = e.target.closest('[data-acc-lightbox-src]');
      if (!trig || !root.contains(trig)) return;
      e.preventDefault();
      open(trig.getAttribute('data-acc-lightbox-src'), trig.getAttribute('data-acc-lightbox-alt') || '');
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (e.target.closest('a[href]')) return;
      var trig = e.target.closest('[data-acc-lightbox-src]');
      if (!trig || !root.contains(trig)) return;
      e.preventDefault();
      open(trig.getAttribute('data-acc-lightbox-src'), trig.getAttribute('data-acc-lightbox-alt') || '');
    });

    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-acc-lightbox-close]')) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || lb.hasAttribute('hidden')) return;
      close();
    });
  }

  function bindTabs(root) {
    var viewport = root.querySelector('[data-acc-tabs-viewport]');
    var tabs = root.querySelectorAll('[data-acc-tab]');
    var panels = root.querySelectorAll('[data-acc-panel]');
    if (tabs.length < 2 || panels.length < 2) return;

    function isMobileTabsViewport() {
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    /** 移动端：非最后一项时把选中 Tab 滚到可视区左沿；最后一项仅在裁切时微调，避免无意义的“贴左”留白 */
    function scrollTabAfterSelect(tabEl) {
      if (!viewport || !tabEl || !isMobileTabsViewport()) return;
      var idx = Array.prototype.indexOf.call(tabs, tabEl);
      if (idx < 0) return;

      var pad = parseFloat(getComputedStyle(viewport).paddingLeft) || 0;
      var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      var cr = viewport.getBoundingClientRect();
      var tr = tabEl.getBoundingClientRect();

      if (idx === tabs.length - 1) {
        if (tr.right > cr.right - 6) {
          viewport.scrollLeft = Math.min(maxScroll, viewport.scrollLeft + (tr.right - cr.right) + 8);
        } else if (tr.left < cr.left + pad) {
          viewport.scrollLeft = Math.max(0, viewport.scrollLeft + (tr.left - cr.left) - pad - 4);
        }
        return;
      }

      var deltaFromLeading = tr.left - cr.left - pad;
      var newLeft = viewport.scrollLeft + deltaFromLeading;
      if (newLeft < 0) newLeft = 0;
      if (newLeft > maxScroll) newLeft = maxScroll;
      viewport.scrollTo({ left: newLeft, behavior: 'smooth' });
    }

    function activate(key) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-acc-tab') === key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-acc-panel') === key;
        if (on) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        activate(t.getAttribute('data-acc-tab'));
        scrollTabAfterSelect(t);
      });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var i = Array.prototype.indexOf.call(tabs, t);
        var next = e.key === 'ArrowRight' ? i + 1 : i - 1;
        if (next < 0) next = tabs.length - 1;
        if (next >= tabs.length) next = 0;
        var nextTab = tabs[next];
        nextTab.focus();
        activate(nextTab.getAttribute('data-acc-tab'));
        scrollTabAfterSelect(nextTab);
      });
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-acc-init') === '1') return;
    root.setAttribute('data-acc-init', '1');
    root.querySelectorAll('[data-acc-panel]').forEach(function (panel) {
      var seen = {};
      panel.querySelectorAll('[data-acc-column]').forEach(function (el) {
        var k = el.getAttribute('data-acc-column');
        if (!k || seen[k]) return;
        seen[k] = true;
        bindColumn(k, panel);
      });
    });
    bindLightbox(root);
    bindTabs(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-accessory-compare-root]').forEach(init);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    if (!evt || !evt.target || !evt.target.querySelectorAll) return;
    evt.target.querySelectorAll('[data-accessory-compare-root]').forEach(init);
  });
})();
